const fonts = {
  SFProDisplay: '"SF Pro Display", Helvetica, sans-serif',
  KlarheitKurrent: '"Klarheit Kurrent", Verdana, sans-serif ',
  DMSans: '"DM Sans", Arial, sans-serif ',
};

export default fonts;
